<template>
  <div class="container">
    <img
      class="header-image"
      :src="props.shippingHeaderImage"
      alt="shipments_header"
    />
    <p class="text-center header-text">
      {{ props.shippingHeaderTitle }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { withDefaults } from "vue";

interface Props {
  shippingHeaderImage: string;
  shippingHeaderTitle: string;
}

const props = withDefaults(defineProps<Props>(), {
  shippingHeaderImage: "",
  shippingHeaderTitle: "",
});
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 11px;
}

.header-image {
  width: 64px;
  height: 64px;
}

.header-text {
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: var(--Typography-Text-1, #111);
  font-feature-settings: "liga" off, "clig" off;
}
</style>
